import { IsBoolean, IsInt, IsNumber, IsOptional, IsString, Length, Max, Min } from 'class-validator';

import { AuctionTypeEnum } from '@onArte/shared/enums/common';

export class AuctionsSearchCriteriaOnWebsiteModel {
  @IsOptional()
  @Length(6, 32)
  public type?: AuctionTypeEnum;

  @IsOptional()
  @IsBoolean()
  public highlighted?: boolean;

  @IsOptional()
  @IsInt()
  public minPrice?: number;

  @IsOptional()
  @IsInt()
  public maxPrice?: number;

  @IsOptional()
  @IsInt()
  public minWidth?: number;

  @IsOptional()
  @IsInt()
  public maxWidth?: number;

  @IsOptional()
  @IsInt()
  public minHeight?: number;

  @IsOptional()
  @IsInt()
  public maxHeight?: number;

  @IsOptional()
  @IsNumber({}, { each: true })
  public categoryIds?: number[];

  @IsOptional()
  @IsString({ each: true })
  public subjectValues?: string[];

  @IsOptional()
  @IsString({ each: true })
  public manufacturerIds?: string[];

  @IsOptional()
  @IsString({ each: true })
  public materialValues?: string[];

  @IsOptional()
  @IsString({ each: true })
  public colorValues?: string[];

  @IsOptional()
  @IsString({ each: true })
  public techniqueValues?: string[];

  @IsOptional()
  @IsString({ each: true })
  public styleValues?: string[];

  @Min(1)
  @Max(100)
  public limit: number;

  @Min(0)
  @Max(100000)
  public offset: number;

  @IsOptional()
  @IsBoolean()
  public sortByHighlighted?: boolean;

  @IsOptional()
  @IsBoolean()
  public hasActiveOffers?: boolean;
  
  constructor(
    type?: AuctionTypeEnum,
    highlighted?: boolean,
    minPrice?: number,
    maxPrice?: number,
    minWidth?: number,
    maxWidth?: number,
    minHeight?: number,
    maxHeight?: number,
    categoryIds?: number[],
    subjectValues?: string[],
    manufacturerIds?: string[],
    materialValues?: string[],
    colorValues?: string[],
    techniqueValues?: string[],
    styleValues?: string[],
    limit: number = 100,
    offset: number = 0,
    hasActiveOffers?: boolean,
    sortByHighlighted: boolean = false,
  ) {
    this.type = type;
    this.highlighted = highlighted;
    this.minPrice = minPrice;
    this.maxPrice = maxPrice;
    this.minWidth = minWidth;
    this.maxWidth = maxWidth;
    this.minHeight = minHeight;
    this.maxHeight = maxHeight;
    this.categoryIds = categoryIds;
    this.subjectValues = subjectValues;
    this.manufacturerIds = manufacturerIds;
    this.materialValues = materialValues;
    this.colorValues = colorValues;
    this.techniqueValues = techniqueValues;
    this.styleValues = styleValues;
    this.limit = limit;
    this.offset = offset;
    this.hasActiveOffers = hasActiveOffers;
    this.sortByHighlighted = sortByHighlighted;
  }
}
